import React, { PropsWithChildren } from 'react';

export function ButtonText({ children }: PropsWithChildren) {
  return <span className="btn__text">{children}</span>;
}
